module.exports = __webpack_public_path__ + "img/icon_1_38.fc366b04.png";